import React from 'react';
import { reportError } from '../../infrastructure/browser/analytics';

interface State {
  error: Error | null;
}

// Si una pantalla se rompe al dibujarse, en vez de quedar en blanco se
// muestra qué pasó y cómo seguir, y el error llega a PostHog.
class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    reportError(error, { componentStack: info.componentStack, path: window.location.pathname });
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div
        role="alert"
        style={{
          minHeight: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 12,
          padding: 24,
          textAlign: 'center',
          background: 'var(--domiot-bg, #FAF8F3)',
          color: 'var(--ion-text-color, #1f2a22)',
          fontFamily: 'Manrope, system-ui, sans-serif',
        }}
      >
        <h2 style={{ margin: 0 }}>Algo no salió bien</h2>
        <p style={{ margin: 0, maxWidth: 360 }}>
          Ya nos llegó el aviso. Probá recargar; si sigue pasando, abrí la app en Google Chrome actualizado.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            border: 0,
            borderRadius: 10,
            padding: '12px 20px',
            background: '#4F7A5C',
            color: '#fff',
            fontWeight: 600,
            fontSize: 16,
          }}
        >
          Recargar
        </button>
        <code style={{ fontSize: 12, opacity: 0.6, maxWidth: 360, wordBreak: 'break-word' }}>{error.message}</code>
      </div>
    );
  }
}

export default ErrorBoundary;
